class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menu = this.querySelector('[data-mega-menu]');
    this.trigger = this.querySelector('.header__menu-item[aria-expanded]');
    this.content = this.querySelector('.mega-menu__content');

    if (!this.trigger || !this.content) return;

    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.close.bind(this));
    this.trigger.addEventListener('focus', this.open.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  get isOpen() {
    return this.trigger?.ariaExpanded === 'true';
  }

  open() {
    document.querySelectorAll('header-menu').forEach((other) => {
      if (other !== this && other.close) other.close();
    });

    this.trigger.ariaExpanded = 'true';
    this.content.removeAttribute('hidden');
    this.menu.classList.add('is-open');

    if (this.header) {
      this.header.preventHide = true;
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  close() {
    if (!this.trigger) return;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('hidden', '');
    this.menu.classList.remove('is-open');

    if (this.header) {
      this.header.preventHide = false;
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      this.trigger.focus();
    }
  }
}

customElements.define('header-menu', HeaderMenu);
